// src/index.ts
import { parse, stringify } from "picoquery";
var selectionToQueryParameter = selection => {
  const formattedSelection = Object.keys(selection).reduce((lowerCasedSelection, key) => {
    lowerCasedSelection[key.toLowerCase()] = selection[key].toLowerCase();
    return lowerCasedSelection;
  }, {});
  return encodeURIComponent(stringify(formattedSelection));
};
var queryParameterToSelection = selectionQueryParameter => {
  if (!selectionQueryParameter) {
    throw new Error("product-code library: queryParameterToSelection()\n      - The parameter selectionQueryParameter is missing empty or not string.");
  }
  const selectionQueryParameters = decodeURIComponent(selectionQueryParameter);
  return parse(selectionQueryParameters);
};
var createProductCode = (url, selection) => "".concat(url, "?selection=").concat(selectionToQueryParameter(selection));
var decodeProductCode = productCode => {
  try {
    const [url, queryParameter] = productCode.split("?selection=");
    return {
      url,
      selection: queryParameterToSelection(queryParameter)
    };
  } catch (_error) {
    throw new Error("Error decoding productCode");
  }
};
export { createProductCode, decodeProductCode, queryParameterToSelection, selectionToQueryParameter };